import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const incidentIo = defineConnector({
  identifier: "incidentIo",
  name: "incident.io",
  tagLine: "Incident management",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.incident\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [incident.io](https://app.incident.io/) and navigate to **Settings > API Keys** to create an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "incident.io API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.incident.io/v2/incidents",
  },
});
